import { render, staticRenderFns } from "./DeliveryTaskList.vue?vue&type=template&id=f7697bf6&scoped=true"
import script from "./DeliveryTaskList.vue?vue&type=script&lang=js"
export * from "./DeliveryTaskList.vue?vue&type=script&lang=js"
import style0 from "./DeliveryTaskList.vue?vue&type=style&index=0&id=f7697bf6&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f7697bf6",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\JSH_ERP\\JSH_ERP\\mgerpweb\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f7697bf6')) {
      api.createRecord('f7697bf6', component.options)
    } else {
      api.reload('f7697bf6', component.options)
    }
    module.hot.accept("./DeliveryTaskList.vue?vue&type=template&id=f7697bf6&scoped=true", function () {
      api.rerender('f7697bf6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/plugin/order-receive/delivery/DeliveryTaskList.vue"
export default component.exports